export enum SignUpFlow {
    DEMO                 = 'DEMO',
    SIGN_UP              = 'SIGN_UP',
    SIGN_UP_AND_DEMO     = 'SIGN_UP_AND_DEMO',
    SIGN_UP_WITHOUT_LINK = 'SIGN_UP_WITHOUT_LINK',
    CLOSED               = 'CLOSED'
}
